/*global autocomplete, dates, myModal, analyticEventTracker, scrollTillFc, inputDirectionChange */

var modification = {
    DATA_LAYER_LABEL_ADD_REMOVE_OPTIONAL_EXTRAS: 'Extras',
    DATA_LAYER_LABEL_UPDATE_DRIVER_DETAILS: 'Driver details',
    DATA_LAYER_LABEL_ADD_CHANGE_FLIGHT_NUMBER: 'Flight number',
    TIMEOUT_IN_MILLISECONDS: 1200,
    p: $('.modal'),
    d: $(document),
    pickDate: '',
    pickFormSubmitted: false,
    init: function() {
        modification.action();
        modification.validateDriverForm();
        modification.validateFlightNumberForm();
        modification.validateExtraForm();
        modification.fc();
        modification.confirmSearch();
        modification.browseOtherCars();
        modification.acceptNewOffer();

        inputDirectionChange.onChangeAction('input,textarea');
    },
    fixArabicNumbers: function(dateText) {
        return dateText.replace(/[٠-٩]/g, function(d) {
            return '٠١٢٣٤٥٦٧٨٩'.indexOf(d);
        });
    },
    action: function() {
        $('.modify-pickup-dropoff').on('click', function(e) {
            e.preventDefault();
            modification.pickFormSubmitted = false;
            const that = $(this);
            const url = that.data('url');
            const modalTitle = that.data('title');

            myModal.staticModal('modifyPickUpDropOffModal', {title: modalTitle, closeOutside: true, noBorder: true});
            modification.openModal(url);
        });

        $(document).on('click', '.modify-action', function(e) {
            e.preventDefault();
            const that = $(this);
            const modalHandler = that.data('modal');
            const modalTitle = that.data('title');
            const timeout = typeof that.data('timeout') !== 'undefined';

            if (timeout) {
                setTimeout(function() {
                    myModal.staticModal(modalHandler, {title: modalTitle, closeOutside: true, noBorder: true});
                    inputDirectionChange.onChangeAction('input,text');
                }, modification.TIMEOUT_IN_MILLISECONDS);
            } else {
                myModal.staticModal(modalHandler, {title: modalTitle, closeOutside: true, noBorder: true});
                inputDirectionChange.onChangeAction('input,text');
            }
        });

        if ($('.modify-action.trigger').length > 0) {
            $('.modify-action.trigger').trigger('click');
        }

        modification.p.on('change', '.extra-item-select', function() {
            let extrasStatesChanged = false;
            const that = $(this);
            const extraCount = parseInt(that.val());
            const handler = $(this).closest('.extra-item-select-box').find('.extra-item-select-text');
            const selected = that.find('option:selected');
            const dataAttributes = selected.data();

            analyticEventTracker.sendInstantEvent(selected.data('eventName'), dataAttributes);

            if (extraCount === 0) {
                handler.removeClass('active selected').text('');
            } else if (extraCount === 1) {
                handler.addClass('active selected').text('');
            } else {
                handler.removeClass('selected').addClass('active').text(extraCount);
            }

            modification.p.find('.extra-item').each(function() {
                const that = $(this);
                const extraCount = parseInt(that.find('.extra-item-select').val());
                const extraInitCount = parseInt(that.data('init-value'));

                if (extraCount !== extraInitCount) {
                    extrasStatesChanged = true;
                }
            });

            modification.p.find('#modificationExtrasBtn').prop('disabled', !extrasStatesChanged);
        });
    },
    validateDriverForm: function() {
        $.validator.addMethod('onlyLatin', function(val) {
            const latinMatch = /^[a-zA-Z\.\'\-\s]+$/;
            const noError = latinMatch.test(val.trim()) !== false;

            if (!noError) {
                dataLayer.push({
                    'onlyLatin': {
                        'action': val
                    },
                    'event': 'onlyLatin'
                });
            }

            return noError;
        });

        modification.p.on('input', 'input[name="driver_firstname"], input[name="driver_lastname"]', function() {
            modification.p.find('#driverNotification').removeClass('d-none');
        });

        modification.p.on('click', '#modificationDriverBtn', function() {

            const that = $(this);

            modification.p.find('#modification-driver-details').validate({
                focusInvalid: false,
                ignore: null,
                errorClass: 'error ws-normal',
                errorElement: 'div',
                groups: {
                    dob: 'driver_birth_dt_day driver_birth_dt_month driver_birth_dt_year'
                },
                errorPlacement: function(error, el) {
                    $(el).parents('.booking-form-row-cell').find('.error-message').append(error);
                },
                invalidHandler: function() {
                    that.removeClass('loading');
                },
                highlight: function(el, ec) {
                    const handler = $(el);
                    const isSelect = (handler[0].localName === 'select');

                    if (isSelect) {
                        handler.parent().removeClass('success').addClass('red').parents('.form-row').addClass('error-field');
                    } else {
                        handler.removeClass('success').addClass(ec).parents('.form-row').addClass('error-field');
                    }
                },
                unhighlight: function(el, ec) {
                    const handler = $(el);
                    const isSelect = (handler[0].localName === 'select');

                    if (isSelect) {
                        handler.parent().removeClass('red').addClass('success').parents('.form-row').removeClass('error-field');
                    } else {
                        if (handler.val().length > 0) {
                            handler.addClass('success');
                        }
                        handler.removeClass(ec).parents('.form-row').removeClass('error-field');
                    }
                },
                submitHandler: function() {
                    that.prop('disabled', true).addClass('loading');

                    let loadingTimer = setTimeout(function() {
                        myModal.staticModal('modifyLoading', {closeOutside: false, noBorder: true, noHeader: true});
                    }, modification.TIMEOUT_IN_MILLISECONDS);

                    const formDataObject = modification.getFormDataObject(modification.p.find('#modification-driver-details'));
                    let modificationUrl = (typeof _d.jv.driverModificationFlow !== 'undefined' && _d.jv.driverModificationFlow === 'v2') ? _d.url.reservation.modification.rq : _d.url.reservation.modification.request;

                    $.ajax({
                        url: modificationUrl,
                        type: 'POST',
                        dataType: 'json',
                        data: formDataObject,
                        success: function(response) {
                            clearTimeout(loadingTimer);
                            that.prop('disabled', false).removeClass('loading');

                            if (typeof _d.jv.driverModificationFlow !== 'undefined' && _d.jv.driverModificationFlow === 'v2') {
                                modification.driverModificationResponseV2(response);
                            } else {
                                modification.driverModificationResponseV1(response);
                            }
                        },
                        error: function() {
                            clearTimeout(loadingTimer);
                            that.prop('disabled', false).removeClass('loading');
                            myModal.staticModal('modifyFailed', {noBorder: true, noHeader: true, 'noCloseButtonInHeader': true});
                        }
                    });
                }
            });
        });
    },
    driverModificationResponseV2: function(response) {
        if (response.success) {

            if (response.data.cancelRebook) {
                if (response.data.viewType === 'not-available') {
                    $('#sameCarNotAvailableBody').html(response.data.htmlBody);
                    myModal.staticModal('modifySameCarNotAvailable', {closeOutside: true});
                } else {
                    $('#sameCarBody').html(response.data.htmlBody);
                    myModal.staticModal('modifySameCar', {title: response.data.title, closeOutside: true});
                }
            } else {
                myModal.staticModal('modifySuccessModal', {closeOutside: true, noBorder: true, noHeader: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});
                modification.sendDataLayerModifyRequestSubmitted(modification.DATA_LAYER_LABEL_UPDATE_DRIVER_DETAILS);
            }

        } else if (response.errorType === 'modificationNotPossible') {
            myModal.staticModal('modifyFailed', {noBorder: true, noHeader: true, 'noCloseButtonInHeader': true});
        } else {
            const handler = $('#modifyDriverLink');
            myModal.staticModal('modifyFailedTryAgain', {closeOutside: false, noBorder: true, noHeader: true});
            modification.p.find('#modifyTryAgainBtn').attr('data-modal', handler.data('modal')).attr('data-title', handler.data('title'));
        }
    },
    driverModificationResponseV1: function(response) {
        if (!response.error) {
            myModal.staticModal('modifySuccess', {title: $('#modifySuccess').data('title'), closeOutside: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});
            modification.sendDataLayerModifyRequestSubmitted(modification.DATA_LAYER_LABEL_UPDATE_DRIVER_DETAILS);
        } else {
            modification.p.find('#modificationDriverBtn').prop('disabled', false).removeClass('loading');
        }
    },
    sendDataLayerModifyRequestSubmitted: function(name) {
        try {
            dataLayer.push({
                'modifyRequestSubmitted': {
                    'action': name
                },
                'event': 'modifyRequestSubmittedV2'
            });
        } catch (err) {}
    },
    validateFlightNumberForm: function() {
        modification.p.on('click', '#modificationFlightBtn', function() {

            const that = $(this);

            modification.p.find('#modification-flight-form').validate({
                focusInvalid: false,
                errorClass: 'error error-message show',
                errorElement: 'div',
                rules: {
                    modification_flight_number: {
                        required: true
                    }
                },
                messages: {
                    modification_flight_number: {
                        required: _d.t.fieldRequired
                    }
                },
                invalidHandler: function() {
                    that.removeClass('loading');
                },
                submitHandler: function() {

                    that.prop('disabled', true).addClass('loading');

                    let loadingTimer = setTimeout(function() {
                        myModal.staticModal('modifyLoading', {closeOutside: false, noBorder: true, noHeader: true});
                    }, modification.TIMEOUT_IN_MILLISECONDS);

                    const formDataObject = modification.getFormDataObject(modification.p.find('#modification-flight-form'));
                    let modificationUrl = (typeof _d.jv.flightNumberModificationFlow !== 'undefined' && _d.jv.flightNumberModificationFlow === 'v2') ? _d.url.reservation.modification.rq : _d.url.reservation.modification.request;

                    $.ajax({
                        url: modificationUrl,
                        type: 'POST',
                        dataType: 'json',
                        data: formDataObject,
                        success: function(response) {
                            clearTimeout(loadingTimer);
                            that.prop('disabled', false).removeClass('loading');

                            if (typeof _d.jv.flightNumberModificationFlow !== 'undefined' && _d.jv.flightNumberModificationFlow === 'v2') {
                                modification.flightNumberModificationResponseV2(response);
                            } else {
                                modification.flightNumberModificationResponseV1(response);
                            }
                        },
                        error: function() {
                            clearTimeout(loadingTimer);
                            that.prop('disabled', false).removeClass('loading');
                            myModal.staticModal('modifyFailed', {noBorder: true, noHeader: true, 'noCloseButtonInHeader': true});
                        }
                    });
                }
            });
        });
    },
    flightNumberModificationResponseV2: function(response) {
        if (response.success) {

            if (response.data.cancelRebook) {
                if (response.data.viewType === 'not-available') {
                    $('#sameCarNotAvailableBody').html(response.data.htmlBody);
                    myModal.staticModal('modifySameCarNotAvailable', {closeOutside: true});
                } else {
                    $('#sameCarBody').html(response.data.htmlBody);
                    myModal.staticModal('modifySameCar', {title: response.data.title, closeOutside: true});
                }
            } else {
                myModal.staticModal('modifySuccessModal', {closeOutside: true, noBorder: true, noHeader: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});
                modification.sendDataLayerModifyRequestSubmitted('Flight number');
            }

        } else if (response.errorType === 'modificationNotPossible') {
            myModal.staticModal('modifyFailed', {noBorder: true, noHeader: true, 'noCloseButtonInHeader': true});
        } else {
            const handler = $('#modifyFlightNumberLink');
            myModal.staticModal('modifyFailedTryAgain', {closeOutside: false, noBorder: true, noHeader: true});
            modification.p.find('#modifyTryAgainBtn').attr('data-modal', handler.data('modal')).attr('data-title', handler.data('title'));
        }
    },
    flightNumberModificationResponseV1: function(response) {
        if (response.isSuccessful) {
            $('.receive-confirmation').remove();
            myModal.staticModal('modifySuccessModal', {closeOutside: true, noBorder: true, noHeader: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});
            modification.sendDataLayerModifyRequestSubmitted('Flight number');
            modification.p.find('#modificationFlightBtn').prop('disabled', false).removeClass('loading');
        } else {
            const handler = $('#modifyFlightNumberLink');
            myModal.staticModal('modifyFailedTryAgain', {closeOutside: false, noBorder: true, noHeader: true});
            modification.p.find('#modifyTryAgainBtn').attr('data-modal', handler.data('modal')).attr('data-title', handler.data('title'));
        }
    },
    validateExtraForm: function() {
        modification.p.on('click', '#modificationExtrasBtn', function(e) {
            e.preventDefault();
            const that = $(this);
            let extraString = '';
            modification.p.find('.extra-item').each(function() {
                const that = $(this);
                const extraCount = parseInt(that.find('.extra-item-select').val());
                const extraInitCount = parseInt(that.data('init-value'));
                const extraPrice = that.find('.extra-price').text().trim();

                if (extraCount > 0 || extraInitCount > 0) {
                    extraString += that.data('name') + ' - x' + extraCount + ' (' + extraPrice + ') ' + '<br/>';
                }
            });

            const formDataObject = modification.getFormDataObject(modification.p.find('#modification-extras-details'));
            Object.assign(formDataObject, {'modification_comment': extraString});

            $.postJSON(_d.url.reservation.modification.request, formDataObject, function(response) {
                if (!response.newFlow) {
                    if (!response.error) {
                        myModal.staticModal('modifySuccess', {title: $('#modifySuccess').data('title'), closeOutside: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});
                        modification.sendDataLayerModifyRequestSubmitted(modification.DATA_LAYER_LABEL_ADD_REMOVE_OPTIONAL_EXTRAS);
                    } else {
                        that.prop('disabled', false).removeClass('loading');
                    }

                    return;
                }

                if (!response.error && !response.ticketCreated) {
                    myModal.staticModal('modifySuccessfulModal', {title: $('#modifySuccessfulModal').data('title'), closeOutside: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});
                    modification.sendDataLayerModifyRequestSubmitted(modification.DATA_LAYER_LABEL_ADD_REMOVE_OPTIONAL_EXTRAS);
                } else {
                    myModal.staticModal('modifySuccess', {title: $('#modifySuccess').data('title'), closeOutside: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});
                    that.prop('disabled', false).removeClass('loading');
                }
            });
        });
    },
    getFormDataObject: function(form) {
        const formData = new FormData(form[0]);
        return Object.fromEntries(formData.entries());
    },
    openModal: function(url) {
        let mWindow = $('#modifyPickUpDropOffModal');
        let mBody = $('.pick-modal-body');
        let mLoadData = $('.pick-modal-load-data');
        let pBody = '';

        mLoadData.show();
        mBody.html('');

        $.getJSON(url, function(response) {
            if (response.error) {
                pBody = response.message;
            } else {
                pBody = response.data.body;
            }

            mLoadData.hide();
            mBody.html(pBody);
            mBody.show();

            setTimeout(function() {
                autocomplete.init('modify-modal');
                modification.select();
                modification.isDropOff();
                modification.calendar();

                mWindow.find('#sb-country').attr('id', 'sb-country-modal');
                mWindow.find('#sb-age').attr('id', 'sb-age-modal');

                const age = $('#age-tooltip');
                age.qtip({
                    position: {
                        my: 'bottom center',
                        at: 'top center'
                    },
                    content: {
                        text: '<span class="qtip-arrow"></span>' + age.attr('data-tooltip')
                    }
                });
                inputDirectionChange.onChangeAction('input,text');
            }, 0);

        });

    },
    calendar: function() {
        let dateFormat = _d.specificDateFormats[_d.s.language] ? _d.specificDateFormats[_d.s.language] : null;

        if (dateFormat === null) {
            dateFormat = (_d.s.language === 'en' ? (_d.sbm ? 'M d, yy' : 'D, M d, yy') : (_d.sbm ? 'd M, yy' : 'D, d M, yy'));
        }

        $('.modal .mr-date-field').each(function() {
            const that = $(this);
            const elementID = that.data('id').replace('-ui', '');
            const parsedDate = $.datepicker.parseDate('yy-mm-dd', $('.modal [data-id=' + elementID + ']').val());
            const newDate = $.datepicker.formatDate(dateFormat, parsedDate, {
                dayNames: _d.t.datepicker_weekdays_full,
                dayNamesShort: _d.t.datepicker_weekdays_short,
                dayNamesMin: _d.t.datepicker_weekdays_short,
                monthNames: _d.t.datepicker_months_full,
                monthNamesShort: _d.t.datepicker_months_short
            });

            that.datepicker({
                firstDay: 1,
                altField: '.modal [data-id=' + elementID + ']',
                altFormat: 'yy-mm-dd',
                numberOfMonths: 2,
                showButtonPanel: false,
                dateFormat: dateFormat,
                prevText: '',
                nextText: '',
                minDate: new Date(new Date().getTime()),
                dayNames: _d.t.datepicker_weekdays_full,
                dayNamesShort: _d.t.datepicker_weekdays_short,
                dayNamesMin: _d.t.datepicker_weekdays_short,
                monthNames: _d.t.datepicker_months_full,
                monthNamesShort: _d.t.datepicker_months_short,
                beforeShow: function(input, inst) {
                    $(input).val(modification.fixArabicNumbers($(input).val()));

                    const pickDateHandler = $('.modal [data-id=pick-date-mr-ui]');
                    modification.pickDate = $('.modal [data-id=pick-date-mr]').val();

                    that.addClass('active');

                    setTimeout(function() {
                        if (window._d.isRTL) {
                            inst.dpDiv.css({
                                top: pickDateHandler.offset().top + modification.p.find('#ui-datepicker-div').height,
                                right: pickDateHandler.offset().right
                            });
                        } else {
                            inst.dpDiv.css({
                                top: pickDateHandler.offset().top + modification.p.find('#ui-datepicker-div').height,
                                left: pickDateHandler.offset().left
                            });
                        }

                        if (inst.dpDiv.position().top > $(input).position().top) {
                            inst.dpDiv
                                .removeClass('ui-above')
                                .addClass('ui-below');
                        } else {
                            inst.dpDiv
                                .removeClass('ui-below')
                                .addClass('ui-above');
                        }
                    }, 0);
                },
                beforeShowDay: function(date) {
                    let dropDate;
                    let pickDateHandler = $('.modal [data-id=pick-date-mr-ui]');
                    let dropDateHandler = $('.modal [data-id=drop-date-mr-ui]');
                    let parsedDate = modification.parseDate(date);

                    if (that.data('id') === 'pick-date-mr-ui') {
                        if (pickDateHandler.hasClass('selected')) {
                            dropDate = dropDateHandler.datepicker('getDate');

                            if (dropDate !== null) {
                                dropDate = modification.parseDate(dropDate);

                                if (dropDate && parsedDate === dropDate) {
                                    return [true, 'ui-state-pickup-date', ''];
                                } else if (modification.pickDate && dropDate && dates.compare(parsedDate, modification.pickDate) > 0 && dates.compare(parsedDate, dropDate) < 0) {
                                    return [true, 'ui-state-pickup-dates', ''];
                                }
                            }
                        }

                        return [true, '', ''];
                    } else if (dropDateHandler.hasClass('selected')) {
                        if (modification.pickDate && parsedDate === modification.pickDate) {
                            return [true, 'ui-state-pickup-date', ''];
                        } else {
                            dropDate = $('[data-id=drop-date-mr]').val();
                            if (modification.pickDate && dropDate && dates.compare(parsedDate, modification.pickDate) > 0 && dates.compare(parsedDate, dropDate) < 0) {
                                return [true, 'ui-state-pickup-dates', ''];
                            }
                        }
                    }

                    return [true, '', ''];
                },
                onSelect: function(dateStr) {
                    dateStr = modification.fixArabicNumbers(dateStr);
                    let pickDateHandler = $('.modal [data-id=pick-date-mr-ui]');
                    let dropDateHandler = $('.modal [data-id=drop-date-mr-ui]');
                    let dropDate = '';

                    modification.p.find('.time-select.err').removeClass('err');
                    modification.p.find('.inline-error').slideUp();

                    //modification.updateDateTime();

                    if (that.data('id') === 'pick-date-mr-ui') {

                        dropDate = that.datepicker('getDate');

                        if (dropDateHandler.datepicker('getDate') < pickDateHandler.datepicker('getDate')) {
                            dropDate.setDate(dropDate.getDate());

                            dropDateHandler.datepicker('option', 'defaultDate', dropDate);
                            dropDateHandler.datepicker('option', 'minDate', dateStr);
                        } else {
                            dropDateHandler.datepicker('option', 'minDate', dateStr);
                        }
                        pickDateHandler.addClass('selected');
                    } else {
                        dropDateHandler.addClass('selected');

                        if (dropDateHandler.datepicker('getDate') < pickDateHandler.datepicker('getDate')) {
                            pickDateHandler.datepicker('setDate', dateStr);
                        }
                    }
                },
                onClose: function() {
                    that.removeClass('active');
                }
            }).val(newDate);
            $('.ui-datepicker').addClass('notranslate');
        });
    },
    select: function() {
        const timeOptions = {
            inherit_select_classes: true,
            disable_search: true,
            no_results_text: _d.t.chosen_no_results_text,
            width: '100%'
        };

        const chosenConfig = {
            '.modal #pick-time-modal': timeOptions,
            '.modal #drop-time-modal': timeOptions
        };

        for (const selector in chosenConfig) {
            if (Object.prototype.hasOwnProperty.call(chosenConfig, selector)) {
                const selectHandler = $(selector);
                const selectVal = selectHandler.val();

                selectHandler.chosen(chosenConfig[selector]);

                if (selectVal > 0) {
                    selectHandler.next().addClass('selected');
                } else {
                    selectHandler.next().addClass('choose');
                }
            }
        }

        $('.time-select').on('change', function() {

            $('.time-select').next().removeClass('err');
            $('.inline-error').slideUp();

            const that = $(this);

            that.addClass('selected');

        }).on('chosen:showing_dropdown', function(e) {
            const time = $(e.target);
            if (time.val() === '0') {
                time.next('.chosen-container').find('.chosen-results').scrollTop(40 * 12);
            }
        });
    },
    parseDate: function(date) {
        date = new Date(date);
        return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);
    },
    isDropOff: function() {
        $('body').on('click', '#is-drop-off-modal', function() {
            const dropOffHandler = modification.p.find('.sb-group.drop-off');
            if ($(this).prop('checked')) {
                dropOffHandler.css({
                    'position': 'absolute',
                    'visibility': 'hidden'
                });
                dropOffHandler.hide();

                modification.p.find('#is-drop-off-modal').prop('checked', true);
            } else {

                modification.p.find('#is-drop-off-modal').prop('checked', false);
                const dropCountry = modification.p.find('#drop-modal-country');
                const dropCity = modification.p.find('#drop-modal-city');
                const dropPlace = modification.p.find('#drop-modal-place');
                const dropCountryValue = parseInt(dropCountry.val());
                const dropCityValue = parseInt(dropCity.val());

                dropCountry.prop('disabled', false).trigger('chosen:updated');

                if ( modification.p.find('#pick-modal-place').val() > 0 && dropCountryValue === 0) {
                    dropCountry.next().addClass('choose');
                }
                if (dropCountryValue > 0) {
                    dropCity.prop('disabled', false).trigger('chosen:updated');
                }
                if (dropCityValue > 0) {
                    dropPlace.prop('disabled', false).trigger('chosen:updated');
                }

                dropOffHandler.css({
                    'position': 'static',
                    'visibility': 'visible'
                });
                dropOffHandler.show();
            }
        });
    },
    confirmSearch: function() {
        // Change pick-up & drop-off OR Change car
        modification.p.on('click', '#sb-form-search-modal', function(e) {
            const that = $(this);
            e.preventDefault();
            that.addClass('loading').prop('disabled', true);
            if (modification.pickFormSubmitted === false) {
                modification.pickFormSubmitted = true;

                let error = false,
                    errorMsg = [],
                    dateFrom = modification.p.find('[data-id=pick-date-mr]').val() + ' ' + modification.p.find('#pick-time-modal').val(),
                    timeFrom = modification.p.find('#pick-time-modal').val(),
                    dateTill = modification.p.find('[data-id=drop-date-mr]').val() + ' ' + modification.p.find('#drop-time-modal').val(),
                    timeTill = modification.p.find('#drop-time-modal').val(),
                    placePick = modification.p.find('#pick-place-modal').val(),
                    placeDrop = modification.p.find('#drop-place-modal').val(),
                    countryID = modification.p.find('#pick-country-modal').val(),
                    driverAge = modification.p.find('#driver-age-input-modal').val();

                if (driverAge === '30-65' || driverAge === '65-30') {
                    driverAge = '35';
                } else if (driverAge === '80+') {
                    driverAge = '80';
                }

                let post = {
                    is_drop_off: (modification.p.find('#is-drop-off-modal').is(':checked') ? 0 : 1),
                    driver_age: driverAge,
                    pick_up_country_id: countryID,
                    pick_up_city_id: modification.p.find('#pick-city-modal').val(),
                    pick_up_location_id: placePick,
                    drop_off_country_id: modification.p.find('#drop-country-modal').val(),
                    drop_off_city_id: modification.p.find('#drop-city-modal').val(),
                    drop_off_location_id: placeDrop,
                    pickup_id: placePick,
                    dropoff_id: placeDrop,
                    pickup_from: dateFrom,
                    pickup_to: dateTill,
                    pick_time: modification.p.find('#pick-time-modal').val(),
                    drop_time: modification.p.find('#drop-time-modal').val(),
                    luxOnly: _d.s.luxOnly,
                    residence_country: modification.p.find('#sb-residence-modal').val(),
                    partner_id: modification.p.find('#partner-id-modal').val(),
                    another_country: modification.p.find('#sb-another').val()
                };

                if (placePick === 0 || modification.p.find('.place-handler.pick').html().length === 0) {
                    modification.p.find('.typeahead.pick').addClass('error');
                    that.removeClass('loading').prop('disabled', false);
                    errorMsg.push(_d.t.selectPickUp);
                    error = true;
                }

                if (post.is_drop_off === 1) {
                    if (placeDrop === 0 || modification.p.find('.place-handler.drop').html().length === 0) {
                        modification.p.find('.typeahead.drop').addClass('error');
                        errorMsg.push(_d.t.selectDropOff);
                        error = true;
                    }
                }

                if (timeFrom === '0') {
                    modification.p.find('.time-select.pick').addClass('err');
                    errorMsg.push(_d.t.selectPickTime);
                    error = true;
                }

                if (timeTill === '0') {
                    modification.p.find('.time-select.drop').addClass('err');
                    errorMsg.push(_d.t.selectDropTime);
                    error = true;
                }

                if (dateFrom === dateTill && timeFrom !== '0' && timeTill !== '0') {
                    modification.p.find('.time-select').addClass('err');
                    errorMsg.push(_d.t.wrongTimes);
                    error = true;
                }

                if (error) {
                    const errorHandler = modification.p.find('.inline-error');
                    errorHandler.html('').append('<ul class="error-list"></ul>');

                    for (let i = 0; i < errorMsg.length; i++) {
                        modification.p.find('.error-list').append('<li>' + errorMsg[i] + '</li>');
                    }

                    that.removeClass('loading').prop('disabled', false);
                    autocomplete.secondFormError();
                    errorHandler.slideDown();
                    return false;
                }

                analyticEventTracker.sendInstantEvent('ModificationRequestSubmitted', that.data());

                $.ajax({
                    method: 'POST',
                    url: _d.url.search.modificationSearch.replace('pickUpId', placePick).replace('dropOffId', placeDrop),
                    data: post
                })
                    .done(function(msg) {
                        if (msg && msg !== false) {
                            if (msg[0] === 'not-available') {
                                $('#sameCarNotAvailableBody').html(msg[1]);
                                myModal.staticModal('modifySameCarNotAvailable', {closeOutside: true});
                            } else if (msg[0] === 'modify-request-received') {
                                modification.d.find('#modification-request-client-text').html(msg[1]);
                                myModal.staticModal('modifyRequestReceivedModal', {'title': $('#modifyRequestReceivedModal').data('title'), closeOutside: true, reloadToMyBooking: true, 'noCloseButtonInHeader': true});

                                try {
                                    dataLayer.push({
                                        'modifyRequestSubmitted': {
                                            'action': 'Pick-up and Drop-off',
                                            'label': 'Manual request'
                                        },
                                        'event': 'modifyRequestSubmittedV2WithLabel'
                                    });
                                } catch (err) {}

                                window.hj=window.hj||function() { (hj.q=hj.q||[]).push(arguments); }; //make sure we can reach out window.hj attribute
                                window.hj('trigger', 'modifyRequestSubmitted');
                            } else {
                                $('#sameCarBody').html(msg[1]);
                                myModal.staticModal('modifySameCar', {modalDialogClass: 'w-900', title: $('#modifySameCar').data('title'), closeOutside: true});
                            }
                        }
                    });

                return true;

            }
        });
    },
    acceptNewOffer: function() {
        modification.p.on('click', '#accept-new-offer', function(e) {
            const that = $(this);

            e.preventDefault();

            that.addClass('loading').prop('disabled', true);

            $.post(modification.d.find('#newDriverDetailsForm').attr('action'), modification.d.find('#newDriverDetailsForm').serialize(), function(response) {
                if (response.success) {
                    document.location.href = response.data.url;
                } else {
                    location.reload();
                }
            }, 'json');
        });
    },
    browseOtherCars: function() {
        modification.p.on('click', '#sb-form-search-modal-browse', function(e) {
            const that = $(this);

            e.preventDefault();

            that.addClass('loading').prop('disabled', true);

            const searchJSON = {
                is_drop_off: modification.d.find('#newIsDropOff').val(),
                driver_age: modification.d.find('#driverAge').val(),
                pick_up_country_id: modification.d.find('#pickUpCountryId').val(),
                pick_up_city_id: modification.d.find('#pickUpCityId').val(),
                pick_up_location_id: modification.d.find('#pickUpLocationId').val(),
                drop_off_country_id: modification.d.find('#dropOffCountryId').val(),
                drop_off_city_id: modification.d.find('#dropOffCityId').val(),
                drop_off_location_id: modification.d.find('#dropOffLocationId').val(),
                pickup_id: modification.d.find('#pickUpId').val(),
                dropoff_id: modification.d.find('#dropOffId').val(),
                pickup_from: modification.d.find('#pickUpFrom').val(),
                pickup_to: modification.d.find('#pickUpTo').val(),
                pick_time: modification.d.find('#pickTime').val(),
                drop_time: modification.d.find('#dropTime').val(),
                luxOnly: _d.s.luxOnly,
                residence_country: modification.d.find('#residenceCountry').val(),
                partner_id: modification.d.find('#partnerId').val(),
                another_country: '-'
            };

            const driverDetailsJSON = modification.d.find('#newDriverDetailsForm').serializeArray().reduce(function(m, o) {  m[o.name] = o.value; return m; }, {});

            const post = Object.assign(searchJSON, driverDetailsJSON);

            $.post(_d.url.search.createSearch, post, function(response) {
                if (response.success) {
                    document.location.href = response.data.url;
                } else {
                    const errorHandler = $('.inline-error.in-modal');

                    $('#sb-form-submit-modal').removeClass('loading');
                    errorHandler.html('').append('<ul id="error-list-modal"></ul>');

                    $.each(response.errors.message, function(index) {
                        if (typeof response.errors.message[index] !== 'undefined') {
                            $('#error-list-modal').append('<li>' + response.errors.message[index] + '</li>');
                        }
                    });

                    $.each(response.errors.fields, function(index, value) {
                        $('#' + value + '-modal').addClass('err');
                    });

                    errorHandler.slideDown();
                }
            }, 'json');
        });
    },
    fc: function() {
        if (typeof scrollTillFc !== 'undefined' && scrollTillFc) {
            const scrollFcBlock = $(document).find('.scroll-fc');

            if (scrollFcBlock.length) {
                $('html, body').animate({
                    scrollTop: scrollFcBlock.offset().top
                }, 2000);
            }
        }

        $('#addFC').on('click', function(e) {
            e.preventDefault();
            const that = $(this);

            that.addClass('loading').prop('disabled', true);

            analyticEventTracker.sendInstantEvent('My_Booking_Add_FC', that.data());

            window.localStorage.setItem('insuranceAdded', that.data('attributeReservation'));

            $.postJSON(_d.url.reservation.modification.request, $('#fc-upsale-form').serialize(), function() {
                setTimeout(function() {
                    window.location.href = _d.url.c.replace('/confirmation/', '/show/');
                }, 2000);
            });
        });

        $('.cancel-fc').on('click', function(e) {
            e.preventDefault();
            const that = $(this);
            if (that.hasClass('clicked')) {
                return false;
            }
            that.addClass('clicked');

            myModal.staticModal('pleaseWaitModal', {noHeader: true, closeOutside: true});

            window.localStorage.removeItem('insuranceAdded');

            $.postJSON(_d.url.reservation.modification.cancelFC, {'number': $(this).data('number'), 'email': $(this).data('email')}, function() {
                setTimeout(function() {
                    window.location.href = _d.url.c;
                }, 2000);
            });
        });
    },
    updateDateTime: function() {
        const newDatetime = modification.parseDate($('.modal [data-id=pick-date-mr-ui]').datepicker('getDate')) + ' ' + $('.modal #mr-pick-time').val() + '::' + modification.parseDate($('.modal [data-id=drop-date-mr-ui]').datepicker('getDate')) + ' ' + $('.modal #mr-drop-time').val();
        $('.modal #reservation-datetime-new-error').html('');
        $('.modal #reservation-datetime-new').val(newDatetime);
    }
};
